import { getGame } from "api/game/get-game";
import subscribeToStream from "api/utils/subscribe-to-stream";
import { GamePayload } from "models/GamePayload";
import { buildGameTypeFromGamePayload, GameType } from "models/GameType";

type SubscribeArgs = { gameId: string; onGameUpdate: (game: GameType | null) => void };
type CleanupFn = () => void;

export const subscribeToGameStream = ({ gameId, onGameUpdate }: SubscribeArgs): CleanupFn => {
  return subscribeToStream<GameType>({
    resourcePath: `/api/game/${gameId}/stream`,
    fetchLatest: () => getGame(gameId),
    parseMessage: (data) => buildGameTypeFromGamePayload(data as GamePayload),
    onUpdate: onGameUpdate,
  });
};

export default subscribeToGameStream;
